import { useEffect, useState } from "react";
import Menu from "./Menu";
import ReportView from "./ReportView";
import {sendSystemLog} from "../../context/AuthProvider/useAuth";

function index() {
  const [selectedReportType, setSelectedReportType] = useState<{
    type: string;
    title: string;
  } | null>(null);
  const log = {
    log_type: 'visited',
    log_object: 'reports'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  

  const setReportType = (type: string, title: string) => {
    setSelectedReportType({ type, title });
  };

  return (
    <div className="reports">
      <Menu setReportType={setReportType} />
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <ReportView
        type={selectedReportType?.type || null}
        title={selectedReportType?.title || null}
      />
    </div>
  );
}

export default index;
